import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { API_BASE_URL } from '../../api';

interface BannerConfig {
  enabled: boolean;
  text: string;
}

const ConstructionBanner: React.FC = () => {
  const [config, setConfig] = useState<BannerConfig | null>(null);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    fetchBannerConfig();
  }, []);

  const fetchBannerConfig = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/system-settings/construction-banner`);
      if (response.ok) {
        const data = await response.json();
        setConfig(data);
      }
    } catch (error) {
      console.error('Failed to fetch construction banner config', error);
    }
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    // Sauvegarder dans localStorage pour ne plus afficher pendant la session
    sessionStorage.setItem('construction_banner_dismissed', 'true');
  };

  // Vérifier si déjà dismissed dans cette session
  useEffect(() => {
    const dismissed = sessionStorage.getItem('construction_banner_dismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  if (!config || !config.enabled || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-40">
      <div className="mx-4 mb-4 rounded-2xl bg-brand text-neutral-offwhite shadow-lg shadow-brand/30 backdrop-blur-sm">
        <div className="container mx-auto flex flex-col gap-2 px-4 py-3 text-center md:flex-row md:items-center md:justify-between md:text-left">
          <div className="flex items-center justify-center gap-2 text-lg font-playfair md:justify-start">
            <AlertTriangle className="h-5 w-5" aria-hidden="true" />
          </div>
          <p className="font-nunito text-sm md:text-base flex-1">
            {config.text}
          </p>
          <button
            onClick={handleDismiss}
            className="hover:bg-brand-dark rounded p-1 transition-colors self-center md:self-auto"
            aria-label="Fermer la bannière"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConstructionBanner;
